export const API = {
  user: '/user',
  updateAvatar: '/user-image',
  getCountries: '/country/get-countries',
  cities: '/cities',
  country: '/country',
  changePassword: '/change-password',
  contactUs: '/contact-us',
  signIn: '/oauth/token',
  forgotPasswordLink: '/password-recovery',
  passwordRecoverCode: '/password-recovery-active',
  subscribe: '/subscribe',
  newPassword: '/new-password',
  socialLogin: '/social-login',
  offers: '/offers',
  requests: '/requests',
  verifyEmail: '/verify-email',
  hotOffers: '/hot-offers',
  suggestion: '/suggestion',
  hotOffer: '/package',
};
